<template>
  <div
    :style="styleObject"
    :class="`pa-skeleton-loader${shimmer ? ' shimmer' : ''}`"
    role="alert"
    :aria-busy="true"
    aria-live="polite"
  />
</template>

<script>
/**
 * @version 1.0.0
 * @description - SkeletonLoader This is a skeleton loader for
 * progressively fetching asynchronous data...
 * the accessibility is handled via 3 aria-roles
 * the role attribute which is set to alert, that
 * is supplemented with the aria-live attribute
 * which is set to polite to softly inform the assistive
 * technologies of updates, and also the aria-busy attribute
 * to inform the assistive technologies that the
 * component is expecting an update
 */
export default {
  name: 'SkeletonLoader',
  computed: {
    styleObject() {
      const {
        height,
        width,
        backgroundColor,
        borderRadius,
        maxWidth,
        minWidth,
      } = this;

      return {
        height,
        width,
        backgroundColor,
        borderRadius,
        maxWidth,
        minWidth,
      };
    },
  },
  props: {
    /**
     * This is used to specify the height of
     * the loader component defaults to 10em
     */
    height: {
      type: [String, Number],
      default: '10em',
      required: true,
      validator(value) {
        return typeof value !== 'number' || !value.match(/^\d+(%|px|em|rem)$/g).length;
      },
    },
    /**
     * This is used to specify the width of
     * the loader component defaults to 10em
     */
    width: {
      type: [String, Number],
      default: '50em',
      required: true,
      validator(value) {
        return typeof value !== 'number' || !value.match(/^\d+(%|px|em|rem)$/g).length;
      },
    },
    /**
     * This is used to specify the background-color of
     * the loader component defaults to '#EFF2F7'
     */
    backgroundColor: {
      type: String,
      default: '#EFF2F7',
      required: false,
    },
    /**
     * This is used to specify the border-radius of
     * the loader component defaults to '5px'
     */
    borderRadius: {
      type: [String, Number],
      default: '5px',
    },
    /**
     * This is used to specify the min-width of
     * the loader component
     */
    minWidth: {
      type: String,
      validator(value) {
        return !value.match(/^\d+(%|px|em|rem)$/g).length;
      },
    },
    /**
     * This is used to specify the max-width of
     * the loader component defaults to 500px
     */
    maxWidth: {
      type: String,
      default: '500px',
      validator(value) {
        return !!value.match(/^\d+(%|px|em|rem)$/g).length;
      },
    },
    /**
     * This is used to specify whether the shimmer
     * animation should be added to the component
     */
    shimmer: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
@import "./skeleton-loader";
</style>
